import { YStack, XStack, Text } from 'tamagui'
import type { BulletsSlide as BulletsSlideType } from '../../../content/decks/types'
import { SlideContainer, SlideInner, getAccentColor, parseLinkedText } from './shared'

export function BulletsSlide({ slide }: { slide: BulletsSlideType }) {
  const accentColor = getAccentColor(slide.accent)
  return (
    <SlideContainer>
      <SlideInner style={{ padding: 'clamp(32px, 6vw, 80px)' }}>
        <Text
          fontFamily="$heading"
          fontWeight="700"
          color={accentColor}
          style={{ fontSize: 'clamp(24px, 3.5vw, 44px)', lineHeight: '1.2em' }}
        >
          {slide.headline}
        </Text>
        <YStack gap="$4" marginTop="$4">
          {slide.items.map((item, i) => (
            <XStack key={i} gap="$3" alignItems="flex-start">
              <Text color={accentColor} style={{ fontSize: 'clamp(14px, 1.5vw, 20px)' }}>
                {'//'}
              </Text>
              <Text
                fontFamily="$body"
                color="$textSecondary"
                flex={1}
                style={{ fontSize: 'clamp(14px, 1.8vw, 22px)', lineHeight: '1.5em' }}
              >
                {parseLinkedText(item)}
              </Text>
            </XStack>
          ))}
        </YStack>
      </SlideInner>
    </SlideContainer>
  )
}
